const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");
const form = require('../../deploynaut/js/Form.jsx');

let AddSecretForm = createReactClass({
	getInitialState: function() {
		return {
			selectedType: 'Env'
		};
	},

	onSetType: function(value) {
		this.setState({
			selectedType: value
		});
	},

	render: function() {
		let fileField = (
			<div className="form-group">
				<label htmlFor="File">File</label>
				<form.FileUpload name="File" />
			</div>
		);

		let formField = (
			<div className="form-group">
				<label htmlFor="Value">Value</label>
				<form.Textarea name="Value"
							   rows="10"
				/>
			</div>
		);

		if (this.state.selectedType === "File") {
			formField = fileField;
		}

		return (
			<form.Form
				ref="addSecretForm"
				url={this.props.actionURL}
				encType="multipart/form-data"
				securityID={this.props.model.SecurityID}
				buttonTitle="Save"
				buttonSubmittingTitle="Saving"
				afterSuccess={this.props.afterSuccess}
				cancelButton={<button className="btn btn-link" onClick={this.props.cancelHandler}>Cancel</button>}
			>
				<div className="form-group">
					<label htmlFor="Type">Type</label>
					<form.Select name="Type"
								 required
								 onSetValue={this.onSetType}
								 validationError="Please choose the type of secret"
								 options={[{id: "Env", value: "Environment variable"}, {id: "File", value: "Local file"}]}
								 value="Env"
					/>
				</div>
				<div className="form-group">
					<label htmlFor="Name">Name</label>
					<form.Input
						name="Name"
						required
						validationError="Please enter a valid name for your secret"
						placeholder="e.g MY_SECRET_TOKEN"
					/>
					<span className="help-text">Names can consist of alphanumeric characters, underscores, and periods</span>
				</div>
				{formField}
			</form.Form>
		);
	}
});

module.exports = AddSecretForm;
